import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'expiryFormat',
})
export class ExpiryFormatPipe implements PipeTransform {
    transform(value?: string): string {
        if (!value) return '';

        const [year, month] = value.split('-');
        const formattedDate: string = `${month}/${year.substring(2)}`; // 'DD/YY' format
        return formattedDate;
    }
}
